import { ReactNode } from "react";
import { Grid, Typography } from "@mui/material";

type CheckScoreItemProps = {
  type: string;
  title: string;
  component?: ReactNode;
  amount?: ReactNode;
};

export const ScoreLayout = ({
  type,
  title,
  component,
  amount,
}: CheckScoreItemProps) => {
  return (
    <Grid container className={type}>
      <Grid
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "left",
          height: "40px",
        }}
        gap={1}
        size="grow"
      >
        <Typography
          className="title"
          sx={{ fontWeight: 700, color: "text.secondary" }}
        >
          {title}
        </Typography>
      </Grid>
      <Grid
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: type === "blast-radius" ? "center" : "right",
        }}
        size={2.6}
      >
        {component}
      </Grid>
      <Grid
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
        className="amount"
        size={3}
      >
        {amount}
      </Grid>
    </Grid>
  );
};
